"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutableContainerConfig = void 0;
exports.RoutableContainerConfig = {
    /** Don't need to do this fast, as it is during scroll. User won't perceive a delay. */
    scrollThrottle: 100,
};
//# sourceMappingURL=RoutableContainer.config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableContainer/RoutableContainer.config.js
// module id = 1008
// module chunks = 8